module.exports = [
  require('./nabassu'),
  require('./nagpa'),
  require('./narzugon'),
  require('./nightwalker'),
  require('./nupperibo'),
]
